import { IApplicationState } from '../../../../../../../types/types';
import { IGoogleDrive, TTabKey } from '../../types';
import { getDrives } from './getDrives';
import { getOpenBoardsTabs } from '../../constants';

export const getDrivesByTabKey = (
    state: IApplicationState,
    tabKey: TTabKey
): IGoogleDrive[] => {
    const drives = getDrives(state);
    const excludeDrives = getOpenBoardsTabs(state)[tabKey].excludeDrives;
    const drivesByTabKey = drives.filter((drive) => {
        const excludeDrivesFilter = (
            !excludeDrives ||
            !excludeDrives.includes(drive.id)
        );
        return excludeDrivesFilter;
    });
    return drivesByTabKey;
}
